// extracted by mini-css-extract-plugin
export var createdDate = "_f7-1";
export var divider = "_f7-2";
export var headerDivider = "_f7-3";
export var messagesCard = "_f7-0";
export var messagesContainer = "_f7-7";
export var messagesContainerWrapper = "_f7-4";
export var pointerCapturingButtonBoxes = "_f7-a";
export var showLeftPanelButton = "_f7-9";
export var showMoreButton = "_f7-c";
export var showMoreButtonContainer = "_f7-b";
export var summaryTitle = "_f7-6";
export var systemMessageCardWrapper = "_f7-d";
export var topButtons = "_f7-8";
export var withPadding = "_f7-5";